import { Availability } from "@/vue-core/models/HotelRoom.model";

interface queryRoom {
  query?: Array<{
    id: string;
    roomCapacityAdults: number;
    roomCapacitychildren: number;
  }>;
  pictures?: Array<string | null>;
  price: number;
  roomCapacityAdults: number;
  roomCapacitychildren: number;
  roomName?: string;
  roomType?: string;
}
const filterAvailavility = (availability: Array<Availability>) => {
  const availabilityFilter = {};
  availability.forEach((item) => {
    const dateFormat = item.startDate.toDate().toISOString().split("T")[0];
    availabilityFilter[dateFormat] = item.quantity;
  });
  return availabilityFilter;
};
export const getRoomsAvailable = (from, to, rooms) => {
  const roomsMap = rooms.reduce((map, room) => {
    const availability = filterAvailavility(room.availability);
    const dates = Object.keys(availability);
    for (const date of dates) {
      if (availability[date] > 0 && date >= from && date <= to) {
        if (!map[date]) map[date] = {};
        const roomCopy = Object.assign({}, room);
        roomCopy.roomsAvailable = availability[date];
        delete roomCopy.availability;
        map[date][roomCopy.roomName] = roomCopy;
      }
    }
    return map;
  }, {});
  return roomsMap;
};
export const getRoomsAvailableAcrossDates = (roomsByDateMap) => {
  const days = Object.keys(roomsByDateMap);
  const firsDayRooms = Object.keys(roomsByDateMap[days[0]]);
  const roomsAvailableAcrossDates = {};
  for (const room of firsDayRooms) {
    let roomAvailable = true;
    for (let i = 1; i < days.length; i++) {
      if (!roomsByDateMap[days[i]][room]) {
        roomAvailable = false;
      }
    }
    if (roomAvailable) {
      for (let i = 0; i < days.length; i++) {
        if (
          !roomsAvailableAcrossDates[room] ||
          roomsAvailableAcrossDates[room].roomsAvailable >
            roomsByDateMap[days[i]][room].roomsAvailable
        ) {
          roomsAvailableAcrossDates[room] = roomsByDateMap[days[i]][room];
        }
      }
    }
  }

  return Object.values(roomsAvailableAcrossDates);
};
export const generateRooms = (roomsCatalog) => {
  const rooms: any = [];
  for (const roomItem of roomsCatalog) {
    for (let i = 0; i < roomItem.roomsAvailable; i++) {
      const room = Object.assign({}, roomItem);
      delete room.roomsAvailable;
      rooms.push(room);
    }
  }
  return rooms.sort((a, b) => {
    return (
      b.roomCapacitychildren - a.roomCapacitychildren ||
      b.roomCapacityAdults - a.roomCapacityAdults
    );
  });
};
export const combinations = (arr, adultSelected, childSelected) => {
  const result: Array<any> = [];
  for (let i = 0; i <= arr.length; i++) {
    const a: Array<any> = [];
    let totalAdults = 0;
    let totalChild = 0;
    for (let j = i; j < arr.length; j++) {
      a.push(arr[j]);
      totalAdults += arr[j].roomCapacityAdults;
      totalChild += arr[j].roomCapacitychildren;
    }
    if (totalAdults >= adultSelected && totalChild >= childSelected) {
      result.push(a);
    }
  }
  return result;
};
export const filterCombinationsWithCapacityNeeded = (
  people,
  child,
  roomPermutations
) => {
  const roomsNeededSet = {};
  for (let i = 0; i < roomPermutations.length; i++) {
    const set: Array<any> = roomPermutations[i];
    const roomsUsed: string[] = [];
    const roomData: queryRoom = {
      query: [],
      pictures: [],
      price: 0,
      roomCapacityAdults: 0,
      roomCapacitychildren: 0,
      roomName: "",
      roomType: "",
    };
    for (
      let p = people, c = child, r = 0;
      (p > 0 || c > 0) && r < set.length;
      p -= set[r].roomCapacityAdults!, c -= set[r].roomCapacitychildren!, r++
    ) {
      roomData.roomCapacityAdults += set[r].roomCapacityAdults!;
      roomData.roomCapacitychildren += set[r].roomCapacitychildren!;
      roomData.price += set[r].price!;
      roomData.roomName +=
        roomData.roomName === "" ? set[r].roomName! : ", " + set[r].roomName!;
      roomData.roomType +=
        roomData.roomType === "" ? set[r].roomType! : ", " + set[r].roomType!;
      if (!roomData.query?.find((element) => element.id === set[r].id))
        roomData.pictures?.push(set[r].picture);
      roomData.query?.push({
        id: set[r].id!,
        roomCapacityAdults: set[r].roomCapacityAdults!,
        roomCapacitychildren: set[r].roomCapacitychildren!,
      });

      roomsUsed.push(set[r].roomName!);
    }
    if (roomData.roomCapacityAdults >= people)
      roomsNeededSet[roomsUsed.sort().join()] = roomData;
  }
  return Object.values(roomsNeededSet);
};
